import React from "react";
import ExperienceCard from "./ExperienceCard";
import {
    experienceHeading,
  } from "../../editable-stuff/configurations.json";

const Experience = () => {

    return (
        <div id="experience" className="jumbotron jumbotron-fluid m-0">
            <div className="container-fluid p-5">
            <h1 className="display-2 pb-5 m-4">{experienceHeading}</h1>
                <div className="justify-content-center m-4">
                    <ExperienceCard />
                </div>
            </div>
        </div>
    );
};

export default Experience;